<template>
  <div class="app-container">
    <div v-show="showList">
    <div class="filter-container">
      <el-button type="primary" @click="showCreateDialog">新增机手</el-button>
    </div>

    <el-table
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
    >
      <el-table-column prop="userName" label="姓名" align="center" />
      <el-table-column prop="userPhone" label="电话" align="center" />
      <el-table-column prop="idCard" label="身份证号" align="center" width="180" />
      <el-table-column prop="createTime" label="创建时间" align="center" width="180" />
      <el-table-column label="操作" align="center" width="120">
    <template slot-scope="scope">
      <el-button
        type="danger"
        size="mini"
        @click="handleDelete(scope.row)"
      >
        删除
      </el-button>
    </template>
  </el-table-column>
    </el-table>

    <el-dialog title="添加机手" :visible.sync="dialogVisible" width="30%">
      <el-form ref="form" :model="formData" :rules="rules">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name" />
        </el-form-item>
        <el-form-item label="身份证号后四位" prop="idCard">
          <el-input v-model="formData.idCard" />
        </el-form-item>
      </el-form>
      <!-- 添加查询结果表格 -->
      <el-table :data="driverList" v-if="driverList.length">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="userPhone" label="联系方式"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              @click="handleSave(scope.row)">
              保存
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">查询</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="showManualAddDialog"
      width="30%">
      <div style="text-align:center;">
        <p>未找到匹配的机手信息，是否手动添加？</p>
      </div>
      <span slot="footer">
        <el-button @click="showManualAddDialog = false">取消</el-button>
        <el-button
          type="primary"
          @click="handleManualAdd">
          手动添加
        </el-button>
      </span>
    </el-dialog>
</div>
    <!-- 新增认证组件 -->
  <jsrz v-if="showAuthComponent" @success="handleAuthSuccess" @cancel="showAuthComponent = false" />
  </div>
</template>

<script>
import {
  selectMachineUser,
  selectUserAuth,
  addMachineUser,
  deleteMachineUser
} from "@/api/njdd.js";
import jsrz from './components/jsrz' // 新增组件导入
export default {
  components: { jsrz }, // 注册组件
  data() {
    return {
      list: [],
      driverList: [], // 新增查询结果列表
      showList: true,
      dialogVisible: false,
      showManualAddDialog: false,
      showAuthComponent: false,
      formData: {
        name: '',
        idCard: ''
      },
      rules: {
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
        ]
      }
    }
  },
  created() {
    //获取我的机手列表
    this.getList();
  },
  methods: {
    showCreateDialog() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确认删除该机手？', '提示', { type: 'warning' })
        await deleteMachineUser({
          id: row.id
        })
        this.$message.success('删除成功')
        this.getList()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败')
        }
      }
    },
    async submitForm() {
      try {
        const res = await selectUserAuth(this.formData);
        if (res.code == 0) {
           this.driverList = res.data || [];
        } else {
          this.showManualAddDialog = true; // 显示手动添加弹窗
        }

      } catch (error) {
        this.showManualAddDialog = true; // 显示手动添加弹窗
      }
    },
    handleManualAdd() {
      this.showManualAddDialog = false;
      this.dialogVisible = false;
      this.showAuthComponent = true;
      this.showList = false;
    },
    handleAuthSuccess() {
      this.showAuthComponent = false;
      this.showList = true;
      this.getList(); // 认证成功后刷新列表
    },
    async handleSave(row) {
      console.log(row, '数据');
      try {
        let res = await addMachineUser({
          areaCode: row.areaCode,
          idCard: row.idCard,
          userId: row.userId,
          userName: row.name,
          userPhone: row.userPhone,
        });
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.dialogVisible = false;
          this.getList(); // 刷新主列表
        }else {
          this.$message.error('保存失败');
        }

      } catch (error) {
        this.$message.error('保存失败');
      }
    },
    async getList() {
      let res = await selectMachineUser();
      if (res.code === 0) {
        this.list = res.data
      }
    }
  }
}
</script>
<style scoped>
.app-container {
  padding: 20px;

  .filter-container {
    margin-bottom: 20px;
    .el-button {
      margin-right: 10px;
    }
  }

  ::v-deep .el-table {
    margin-top: 20px;
    th {
      background-color: #f5f7fa;
    }
  }

  .el-dialog {
    ::v-deep .el-form-item {
      margin-bottom: 22px;
      .el-form-item__label {
        width: 100px;
        text-align: right;
        padding-right: 20px;
      }
      .el-input {
        width: 250px;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .el-dialog {
    width: 90% !important;

    ::v-deep .el-input {
      width: 100% !important;
    }
  }
}
</style>
